import { VImg } from 'vuetify/lib/components/VImg';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "a",
    { attrs: { href: _setup.reverseFull({ name: "prodoctorov_main" }) } },
    [
      _c(VImg, {
        attrs: {
          contain: "",
          width: "236",
          height: "36",
          src: _setup.logoPath,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }